import { PATH_DASHBOARD } from 'src/routes/paths'

export function getCommunityPageBackKey(communityId) {
  return communityId ? `communityPageBack_${communityId}` : null
}

export function readCommunityPageBackFromLocation(location) {
  return {
    fromClientProject: Boolean(location?.state?.fromClientProject),
    clientProjectBackState: location?.state?.clientProjectBackState || null,
  }
}

export function buildCommunityListState({
  communityId,
  communityName,
  projectsClients,
  fromClientProject,
  clientProjectBackState,
}) {
  if (!communityId) return null
  return {
    id: communityId,
    name: communityName,
    ...(projectsClients ? { clients: projectsClients } : {}),
    ...(fromClientProject && clientProjectBackState
      ? { fromClientProject: true, clientProjectBackState }
      : {}),
  }
}

export function buildCommunityNavigateState(id, name, clients, clientProjectBackState) {
  return {
    id,
    name,
    ...(clients ? { clients } : {}),
    ...(clientProjectBackState
      ? { fromClientProject: true, clientProjectBackState }
      : {}),
  }
}

export function persistCommunityPageBack(pageBackKey, fromClientProject, clientProjectBackState) {
  if (!pageBackKey) return
  try {
    sessionStorage.setItem(
      pageBackKey,
      JSON.stringify({ fromClientProject, clientProjectBackState }),
    )
  } catch (e) {
    /* ignore */
  }
}

export function navigateCommunityPageBack(
  navigate,
  fromClientProject,
  clientProjectBackState,
  pageBackKey,
) {
  let backFromClient = fromClientProject
  let backClientState = clientProjectBackState
  if (!backFromClient && pageBackKey) {
    try {
      const raw = sessionStorage.getItem(pageBackKey)
      if (raw) {
        const parsed = JSON.parse(raw)
        backFromClient = Boolean(parsed?.fromClientProject)
        backClientState = parsed?.clientProjectBackState || null
      }
    } catch (e) {
      /* ignore */
    }
  }
  if (pageBackKey) {
    sessionStorage.removeItem(pageBackKey)
  }
  if (backFromClient && backClientState) {
    navigate(PATH_DASHBOARD.client.projectClient, {
      replace: true,
      state: backClientState,
    })
  } else {
    navigate(PATH_DASHBOARD.community.root, { replace: true })
  }
}
